export enum AddBorrowersState {
    Valid = 0,
    EqualToCustomer = 1,
    ExistInBorrowers = 2,
}



// WEBPACK FOOTER //
// ./src/app/enums/add-borrowers-state.ts